import { useRef, useEffect, useCallback } from 'react';

export function useGADataLayer(limit = 10) {
  const viewItems = useRef([]);

  useEffect(() => {
    if (typeof window !== 'undefined' && !window.dataLayer) {
      window.dataLayer = [];
    }

    return () => {
      processViewItems();
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(processViewItems, 2000);

    return () => {
      clearTimeout(interval);
      processViewItems();
    };
  }, [limit]);

  function processViewItems() {
    if (
      typeof window !== 'undefined' &&
      window.dataLayer &&
      viewItems.current.length
    ) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          items: viewItems.current.map((item, index) => ({
            ...item,
            index: index + 1,
          })),
        },
      });
      viewItems.current = [];
    }
  }

  const trackItemView = useCallback(item => {
    processViewItems();
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'NOK',
        items: [item],
      },
    });
  }, []);

  const trackItemViewList = useCallback(data => {
    const exists = viewItems.current.find(
      item => item.item_id === data.item_id
    );

    if (exists) {
      return;
    }

    viewItems.current.push(data);
    if (viewItems.current.length >= limit) {
      processViewItems();
    }
  }, []);

  const trackSelectItem = useCallback(item => {
    return new Promise(resolve => {
      if (typeof window !== 'undefined' && window.dataLayer) {
        processViewItems();
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'select_item',
          ecommerce: {
            currency: 'NOK',
            value: item.price,
            item_list_id: item.item_list_id,
            item_list_name: item.item_list_name,
            items: [item],
          },
        });
      }
      resolve();
    });
  }, []);

  return {
    trackItemView,
    trackItemViewList,
    trackSelectItem,
  };
}

export default useGADataLayer;
